import * as yup from "yup";
import {englishCharRegExp, phoneRegExp} from "../../../services/regex";
import {withFormik} from "formik";
import {isNotEmpty} from "../../../helpers/functions";
import httpClient from "../../../services/httpClient";
import {couponsApi} from "../../../constans/apiUrls";
import {ICouponData} from "../../../contracts/data/coupon";
import {CouponLimitType, CouponsValueType} from "../../../constans/enumTypes";
import InnerCouponForm from "../../../components/FormTemplates/coupon/InnerCouponForm";


const newCouponFormValidationSchema = yup.object().shape({
    title: yup.string().required("عنوان الزامی میباشد"),
    hash: yup.string().required("کد الزامی میباشد").matches(englishCharRegExp, "حروف کد باید انگلیسی باشد"),
    stock: yup.number().required("تعداد استفاده از کد الزامی میباشد").min(1, "تعداد استفاده از کد حداقل 1 میباشد"),
    expired_day: yup.number().required("مدت اعتبار کد الزامی میباشد").min(1, "حداقل مدت اعتبار کد باید بیشتر از یک باشد"),
    value: yup.number().required("مقدار کد تخفیف الزامی میباشد"),
    mobile: yup.string().nullable().length(11, "شماره موبایل 11 رقم میباشد").matches(phoneRegExp, "شماره موبایل نادرست میباشد")
})

interface INewCouponFormProps {
    formType?: string,
}

const CouponForm = withFormik<INewCouponFormProps, ICouponData>({
    mapPropsToValues: props => ({
        id: 0,
        title: '',
        hash: '',
        stock: 0,
        coupon_type: CouponsValueType.PERCENT,
        expired_day: 0,
        value: 0,
        high_discount: 0,
        low_price: 0,
        special_user: false,
        user_mobile: '',
        limit_type_product: CouponLimitType.ALL_BASKET,
    }),
    mapPropsToStatus: props => ({
        formType: props.formType,
    }),
    validationSchema: newCouponFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        formikBag?.setFieldValue('special_user', isNotEmpty(values.user_mobile))
        if (formikBag.props.formType === 'create') {
            await httpClient().post(couponsApi.create, values)
                .then(response => {
                    if (response.status === 201 || response.status === 200) {
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error.response.data
                }))
        } else if (formikBag.props.formType === 'edit') {
            await httpClient().put(`${couponsApi.update}/${values.id}`, values)
                .then(response => {
                    if (response.status === 200) {
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error.response.data
                }))
        }
    },
    displayName: 'CouponForm'
})(InnerCouponForm)

export default CouponForm